import React from 'react';
import styles from './style.module.scss';

interface ButtonProps {
  text: string;
  color?: 'danger' | 'primary' | 'success';
  onClick?: () => void;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  text, color, onClick, disabled,
}) => {

  return (
    <button
      className={`${styles.button} ${disabled ? styles.disabled : styles[color as keyof typeof styles]}`}
      onClick={!disabled ? onClick : undefined}
    >
      {text}
    </button>
  );

};

export default Button;
